import React from 'react';
import logo1 from '../../../assets/images/brand-logos/logo_1.png';

const titleCase = (str: string) =>
  str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());

const DocumentFooter: React.FC<{ pageNo?: number }> = ({ pageNo = 1 }) => {
  const footerData = {
    title: 'Survey Calculation Report',
    subject: 'Phase 1 Analysis',
    category: 'Geology',
  };

  const backgroundImage = `url('data:image/svg+xml;utf8,<svg width="794.85" height="50" xmlns="http://www.w3.org/2000/svg"> <polygon points="608,7 618,7 603,43 593,43" style="fill:%23DC1010;" /><polygon points="625,7 635,7 620,43 610,43" style="fill:%23DC1010;" /><polygon points="643,7 753.85,7 795.85,43 628,43" style="fill:%23DC1010;" /></svg>')`;
  // const backgroundImage = `url('data:image/svg+xml;utf8,<svg width="794.85" height="50" xmlns="http://www.w3.org/2000/svg"> <polygon points="0,0 640,0 620,50 0,50" style="fill:%23f3f4f6;" /><polygon points="648,7 658,7 643,43 633,43" style="fill:%23DC1010;" /><polygon points="665,7 675,7 660,43 650,43" style="fill:%23DC1010;" /><polygon points="683,7 793.85,7 795.85,43 668,43" style="fill:%23DC1010;" /></svg>')`;

  return (
    <div
      className="w-full flex justify-between items-center mt-0 px-2"
      style={{
        height: '50px',
        backgroundImage: backgroundImage,
        backgroundSize: 'cover',
      }}
    >
      {/* Left: Logo + Text */}
      <div className="flex items-center gap-3 flex-1 min-w-0">
        <img src={logo1} alt="Logo" className="h-[45px]  max-w-full" />
        <span className="text-[12px] truncate">
          {titleCase(footerData.title)} - {titleCase(footerData.subject)} - {titleCase(footerData.category)}
        </span>
      </div>

      {/* Right: Page Number */}
      <div className="text-white  text-sm flex-shrink-1 text-right">
        Page | {pageNo}
      </div>
    </div>
  );
};

export default DocumentFooter;
